import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class NotificacaoService {
  private data = null;
	private url = environment.serviceApi;

  constructor(public http: Http) { }
  
  getNotificacoes(usuario_id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/notificacoes/' + usuario_id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
